export default function CFIsOverview() {
  const features = [
    {
      icon: 'ri-dashboard-line',
      title: 'Student Progress Dashboard',
      description: 'Monitor all your students in one unified view. Track flight hours, skill progression, and readiness metrics across your entire roster with real-time updates.',
      highlights: [
        'Multi-student overview',
        'Skill score tracking',
        'Flight history timeline',
        'Custom notes & tags'
      ]
    },
    {
      icon: 'ri-presentation-line',
      title: 'Debrief Tools',
      description: 'Transform post-flight debriefs with interactive flight replay, AI-generated insights, and annotation tools. Show students exactly what happened—and why it matters.',
      highlights: [
        'Flight replay theater',
        'Annotate key moments',
        'AI coaching insights',
        'Export debrief reports'
      ]
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Pre-Solo Readiness Reports',
      description: 'Get comprehensive readiness assessments aligned with ACS standards. Make confident go/no-go decisions backed by objective data and trend analysis.',
      highlights: [
        'ACS standards breakdown',
        'Proficiency scoring',
        'Recommendation engine',
        'Progress trend charts'
      ]
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#0A1628] to-[#0F1F38]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Built for <span className="text-[#00FFD1]">Instructors</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Everything you need to deliver exceptional flight training—streamlined, data-driven, and designed with CFIs in mind.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-[#0A1628]/50 backdrop-blur-sm border border-[#00FFD1]/20 rounded-xl p-8 hover:border-[#00FFD1]/50 hover:shadow-xl hover:shadow-[#00FFD1]/10 transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center bg-[#00FFD1]/10 rounded-lg mb-6 group-hover:bg-[#00FFD1]/20 transition-colors">
                <i className={`${feature.icon} text-[#00FFD1] text-3xl`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold mb-4 text-white group-hover:text-[#00FFD1] transition-colors">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-400 mb-6 leading-relaxed">
                {feature.description}
              </p>

              {/* Highlights */}
              <ul className="space-y-3">
                {feature.highlights.map((highlight, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-[#00FFD1] text-lg mt-0.5 flex-shrink-0"></i>
                    <span className="text-sm text-gray-300">{highlight}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 mb-6">
            Join the growing community of instructors using WingmanFix to transform their training programs.
          </p>
          <a
            href="/waitlist"
            className="inline-flex items-center gap-2 px-6 py-3 bg-transparent border border-[#00FFD1] text-[#00FFD1] rounded-lg font-medium hover:bg-[#00FFD1]/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-user-add-line text-lg"></i>
            Request Early Access
          </a>
        </div>
      </div>
    </section>
  );
}